/** Alinhado ao semver do app em Aplicativo_zehmotoca/mobile/package.json (header X-App-Version). */
export const CLIENTE_MOBILE_APP_VERSION = '1.0.10';
